import Vue from 'vue';
import VueI18n from 'vue-i18n';


import zh from './zh';
import tw from './tw';
import en from './en';
Vue.use(VueI18n);

const messages = {
  'zh-CN': zh,
  'zh-TW': tw,
  'en':en
}

const getLanguage = () => {
  let url = decodeURIComponent(location.search);
  if(url.includes('lang=tw')) {
    return 'zh-TW';
  }
  if(url.includes('lang=en')) {
    return 'en';
  }
  return navigator.language;
};

const i18n = new VueI18n({
  messages,
  locale: getLanguage()   
})
export default i18n;
